export function parseStringToInt(val: string): number {
    try {
        const parsed = parseInt(val, 10);
        if (isNaN(parsed)) {
            return 0;
        }

        return parsed;
    } catch {
        return 0;
    }
}